module.exports = __webpack_public_path__ + "static/media/canada.ca3d382c.svg";